import React, { PureComponent } from 'react'
import cx from 'classnames'
import { array } from 'prop-types'
import isEmpty from 'lodash.isempty'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import styles from './styles.module.less'

import MessageItem from './MessageItem'

class Conversations extends PureComponent {
  static propTypes = {
    messages: array,
  }
  bodyPartsRef = null

  setConversationBodyPartsRef = ref => {
    this.bodyPartsRef = ref
  }

  renderChats = messages => {
    let botMessageIndex = -1
    return messages.map((message, messageKey) => {
      if (isEmpty(message.state.attributes)) {
        return null
      }
      const isBotMessage = message.state.author === 'bot'
      botMessageIndex = isBotMessage ? ++botMessageIndex : botMessageIndex
      return (
        <CSSTransition
          key={`messageAnimation${messageKey}`}
          unmountOnExit
          timeout={600}
          classNames='move'
        >
          <MessageItem
            key={`messageItem${messageKey}`}
            channel={message.conversation}
            message={message.state}
            staffMembers={this.props.staffMembers}
            isWidget={this.props.isWidget}
            outgoing={message.state.author === this.props.identity}
            userEmail={this.props.userEmail}
            botMessageIndex={isBotMessage ? botMessageIndex : -1}
          />
        </CSSTransition>
      )
    })
  }

  bodyOnClick = () => {
    const { resetUnreadStates } = this.props

    if (typeof resetUnreadStates === 'function') {
      resetUnreadStates()
    }
  }

  render() {
    const {
      messages,
      isChatOnlyFeature,
      staffMembers,
      headerHeight,
      isMobileWidth,
      isWidget,
    } = this.props

    const hasMessages = messages.length > 0
    const hasStaffMembers = staffMembers && staffMembers.length
    const chatPadding = isMobileWidth || isWidget ? 10 : hasStaffMembers ? 40 : 10

    const classNamesBody = cx({
      [styles.conversationBody]: true,
      [styles.conversationBodyWithMessages]: hasMessages,
      [styles.conversationBodyWithoutMessages]: !hasMessages,
      [styles.conversationBodyWithoutBottomNav]: isChatOnlyFeature,
      [styles.conversationBodyWithStaffList]: hasStaffMembers,
      [styles.conversationBodyWithoutStaffList]: !hasStaffMembers,
    })

    const classNamesBodyParts = cx({
      [styles.conversationBodyParts]: true,
      [styles.conversationBodyPartsWithMessages]: hasMessages,
    })

    return (
      <div
        className={classNamesBody}
        onClick={this.bodyOnClick}
        style={{
          marginTop: headerHeight + 'px',
          height: 'calc(100% - ' + (headerHeight + chatPadding) + 'px)',
        }}
      >
        <div className={classNamesBodyParts}>
          <div className={styles.conversationPartsWrapper} ref={this.setConversationBodyPartsRef}>
            <div
              className={styles.conversationParts}
              style={{ paddingBottom: isWidget || hasStaffMembers ? '0' : '32px' }}
            >
              <TransitionGroup appear={true} component={null}>
                {this.renderChats(messages)}
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Conversations
